import { RootStateOrAny } from "react-redux";
import { AnyAction } from "@reduxjs/toolkit";
import {
    AUTH_LOCALSTORAGE_KEY,
    AUTH_LOGGED_OUT,
    AUTH_SET_TABLE_DEFINITION,
    AUTH_SUCCESS,
} from "@/Redux/Auth/AuthConstants";
import { UserState } from "@/Redux/User/UserReducer";

export type ViewerState = typeof INITIAL_STATE;

const INITIAL_STATE = {
    initialized: false,
    isLoggedIn: false,
    viewer: {
        id: null,
        username: null,
        firstName: null,
        lastName: null,
        accountType: null,
        dispositionCalenderAmountOfDaysShownBeforeToday: 3,
        dispositionCalenderAmountOfDaysShownAfterToday: 7,
        dispoDaysBefore: null,
        dispoDaysAfter: null,
        hasMinimalRights: false,
        rights: null,
        homeStation: null,
        emailSignature: null,
        defaultLanguage: null,
    },
    tableDefinitions: [],
};

export default function AuthReducer(state = INITIAL_STATE, action: AnyAction) {
    switch (action.type) {
        case AUTH_SUCCESS:
            localStorage.setItem("username", action.payload.viewer.username);
            return {
                ...state,
                isLoggedIn: true,
                viewer: action.payload.viewer,
            };
        case AUTH_LOGGED_OUT:
            return {
                ...INITIAL_STATE,
            };
        case AUTH_SET_TABLE_DEFINITION:
            return {
                ...state,
                tableDefinitions: action.payload,
            };
        default:
            return state;
    }
}

export const getState = (state: RootStateOrAny) => {
    if (typeof state.auth === "object") {
        return state.auth;
    }
    return state;
};

export const selectIsLoggedIn = (state: ViewerState) => {
    return getState(state).isLoggedIn;
};

export const selectAuthToken = () => {
    return localStorage.getItem(AUTH_LOCALSTORAGE_KEY);
};

export const selectViewerAccountType = (state: ViewerState) => {
    return getState(state).viewer.accountType;
};

export const selectViewerPrintname = (state: ViewerState) => {
    return getState(state).viewer.printname;
};

export const selectUserId = (state: ViewerState) => {
    return getState(state).viewer.userId;
};

export const selectDispoDaysBefore = (state: ViewerState) => {
    return getState(state).viewer.dispoDaysBefore;
};

export const selectDispoDaysAfter = (state: ViewerState) => {
    return getState(state).viewer.dispoDaysAfter;
};

export const selectViewerEnabledStations = (state: ViewerState) => {
    return getState(state).viewer.enabledStations;
};

export const selectViewerHomeStation = (state: ViewerState) => {
    return getState(state).viewer.homeStation;
};

export const selectViewerDefaultRegion = (state: ViewerState) => {
    return getState(state).viewer.defaultRegion;
};

export const selectViewerEnabledGroups = (state: ViewerState) => {
    return getState(state).viewer.enabledGroups;
};

export const selectHasMinimalRights = (state: ViewerState) => {
    return getState(state).viewer.hasMinimalRights;
};

export const selectViewerEnabledRegions = (state: ViewerState) => {
    return getState(state).viewer.enabledRegions;
};

export const selectViewerRights = (state: ViewerState) => {
    return getState(state).viewer.rights;
};

export const selectViewerTableDefinition = (
    state: ViewerState,
    formName: string,
    gridName: string,
) => {
    if (getState(state).tableDefinitions[formName] == undefined) {
        return {};
    }
    if (getState(state).tableDefinitions[formName][gridName] == undefined) {
        return {};
    }
    return (
        JSON.parse(getState(state).tableDefinitions[formName][gridName]) || {}
    );
};

export const selectAllViewerTableDefinition = (state: ViewerState) => {
    return getState(state).tableDefinitions;
};

export const selectViewerUsername = (state: ViewerState) => {
    return getState(state).viewer.username;
};

export const selectEmailSignature = (state: ViewerState) => {
    return getState(state).viewer.emailSignature;
};

export const selectDefaultLanguage = (state: ViewerState) => {
    return getState(state).viewer.defaultLanguage;
};
